import { useState } from "react";
import useApi from "../../api";
import { useDeleteConfirmation } from "../common";
import GenericSelectableTable from "../selectableTable";
import { toast } from "react-toastify";
import ReturnRequestForm from "./returnRequestForm";


interface OrderTableProps {
    data: any;
}

function OrderedLineItemsTable({data}:OrderTableProps) {
  const [stockId, setStockId] = useState<any>(null)
  const {handleDelete}  = useDeleteConfirmation();
  const [selectedLineItems, setSelectedLineItems] = useState([]);
  const [isReturnFormOpen, setReturnFormOpen] = useState(false);


  const api = useApi()

  const lineItemTableColumns = [
    { header: 'Item', key: 'variant.displayName' },
    { header: 'Variant Price', key: 'variant.humanizePrice' },
    { header: 'Quantity', key: 'quantity' },
    { header: 'Adjusted Price', key: 'humanizePricePerUnit' },
    { header: 'Total Price', key: 'humanizeTotalPrice' },
  ]

  const LineItembullkAction = [
    {
      label: 'Intiate Return',
      onClick: (selectedItems:any) => {

        if (data?.status !== 'DELIVERED') {
          toast.error("Only delivered orders can be returned.");
          return;
        }


        setSelectedLineItems(Array.from(selectedItems));
        setReturnFormOpen(!isReturnFormOpen);
      },
    },
    // { # FUTURE TODO: Directly import to order create form"
    //   label: 'Recover Selected',
    //   onClick: (selectedItems:any) => {
    //     if (data?.status !== 'CANCELLED') {
    //         toast.error("Order  must be cancelled to recover selected items. Please cancel the order first.");
    //       return;
    //     }
    //   },
    // },
  ];
  
 
  return (
    <div>
      <div className="overflow-x-auto">
        <GenericSelectableTable columns={lineItemTableColumns} data={data?.lineItems || []}  bullkActionButtons={LineItembullkAction}  />
      </div>

       {/* All modal & drawer goes there */}

       {isReturnFormOpen &&  <ReturnRequestForm
        isOpen={isReturnFormOpen}
        onClose={() => setReturnFormOpen(!isReturnFormOpen)}
        order_id={data?.dbId}
        lineItems={data?.lineItems || []}
        selectedItems={selectedLineItems}
      />}
      
      
    </div>
  )
}

export default OrderedLineItemsTable